import React from 'react';

import urlBuilder from '../../Shared/url-builder';
import { Header } from '../BettermentForAdvisors/Header';

const NAVIGATION: {
  label: string;
  to: string;
  isExact: boolean;
  shouldReloadDocument?: boolean;
}[] = [
  {
    label: 'Settings',
    to: urlBuilder.getClientAgreementSignaturePage.absolutePath,
    isExact: true,
  },
  {
    label: 'Client packages',
    to: urlBuilder.getSummaryPage.absolutePath,
    isExact: true,
  },
];

export const ClientAgreementsSignatureHeader: React.FC<{ isLegacyAgreementsPage: boolean }> = ({
  isLegacyAgreementsPage,
}) => {
  return (
    <Header
      title="Agreements"
      navigation={isLegacyAgreementsPage ? [] : NAVIGATION}
      css={{
        bg: 'background.surface',
        display: 'flex',
        flexDirection: 'column',
      }}
    />
  );
};
